export const TipLabel = () => null;
